import React from 'react'

import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'

interface Props {
  isBedbank: boolean
  offerPage: boolean
  finePrintUrl: string
  onFinePrint: () => void
}

function TaxAndFeesText({ isBedbank, offerPage, finePrintUrl, onFinePrint }: Props) {
  const finePrintLabel = isBedbank ? 'Terms and Conditions' : '‘Fine Print’'
  const finePrintLink = offerPage ?
      <TextLink weight="regular" onClick={onFinePrint}>{finePrintLabel}</TextLink> :
      <TextLink weight="regular" to={finePrintUrl}>{finePrintLabel}</TextLink>

  if (isBedbank) {
    return (<BodyText variant="medium" as="p">
      The taxes are tax recovery charges paid to vendors (e.g., hotels); for details, please see our Terms of Use.
      Service fees are retained as compensation in servicing your booking and may include fees charged by vendors.
      For more details, please see the {finePrintLink}.
    </BodyText>)
  }

  return (
    <BodyText variant="medium">
      This charge includes estimated amounts the travel service provider pays for their taxes, and/or taxes that we pay, to taxing
      authorities on your booking (including but not limited to sales, occupancy, and value-added tax). This amount may also include
      any amounts charged to us for resort fees, cleaning fees, and other fees and/or a fee we, the website you booked on, retain as
      part of the compensation for our and/or their services, which varies based on factors such as location, the amount, and how
      you booked. Please refer to the {finePrintLink} for any additional costs payable directly to the property.
    </BodyText>
  )
}

export default TaxAndFeesText
